<template>
  <div class="page-addresses">
    <div class="title">{{$t('menu.member_addr')}}</div>
    <template v-if="mAddrList.length > 0">
      <div v-for="(addr, i) in mAddrList" :key="addr.id" style="padding: 0 25px 25px 25px">
        <MyAddr :value="addr" @on-click="addrChoice(addr)" @on-change-default="changeDefault($event,addr,i)" :setDefaultLoading="loading">
          <div slot="action" class="img-btn-group">
            <img src="@/assets/icon-btn-edit.png" height="24" @click.stop="onAddrEdit(addr,i)" alt="">
            <img src="@/assets/icon-btn-del.png" height="24" @click.stop="onAddrDelete(addr.id,i)" alt="">
          </div>
        </MyAddr>
      </div>
    </template>
    <p v-else-if="!loading"
       class="no-content-tip">{{$t('page.addr.no_address')}}</p>
    <div>
      <div :style="{height:footerButtonHeight+'px'}"></div>
      <div ref="bottomButtons" class="bottom-buttons bottom-buttons-fixed">
        <Button class="btn btn-ok" long
                @click="onAddrEdit(null)"
                icon="md-add">{{$t('page.addr.btn_new')}}</Button>

        <Button @click="handleBack"
                class="btn">{{$t('common.btn_back')}}</Button>
      </div>
    </div>
    <Modal v-model="mAddrEditShow" footer-hide
           class-name="narrow-modal"
           :title="mAddr?$t('addr.title'):$t('addr.title_new')">
      <AddrEdit v-if="mAddrEditShow" :addr="mAddr" deletable style="margin-bottom: 10px;"
                :def="mAddrList.length===0"
                @on-save="onAddrSave" @on-delete="onAddrDelete"/>
    </Modal>
  </div>
</template>
<script>
    import MyAddr from '@/components/MyAddr';
    import AddrEdit from '@/components/AddrEdit';
    import common from '@/mixins/common';
    import { httpDelete, httpPost } from '@/api/http';

    export default {
        components: {
            MyAddr,
            AddrEdit
        },
        props: {
            isWindow: {
                type: Boolean,
                default: false
            }
        },
        mixins: [common],
        data () {
            return {
                loading: false,
                setDefaultLoading: false,
                mAddrList: [],
                mAddrIndex: -1,
                mAddrEditShow: false,
                mAddr: null
            }
        },
        methods: {
            onAddrEdit (addr, index = -1) {
                if (addr) {
                    this.mAddr = addr;
                    this.mAddrIndex = index
                } else {
                    this.mAddr = null;
                    this.mAddrIndex = index
                }
                this.mAddrEditShow = true;
            },
            onAddrSave (addr) {
                if (addr) {
                    // if (this.mAddr) {
                    //     // edit
                    //     for (let i = 0; i < this.mAddrList.length; i++) {
                    //         if (this.mAddrList[i].id === addr.id) {
                    //             this.mAddrList[i] = addr;
                    //         } else if (addr.is_default !== this.mAddr.is_default) {
                    //             this.mAddrList[i].is_default = false;
                    //         }
                    //     }
                    // } else {
                    //     // new
                    //     if (addr.is_default) {
                    //         for (let i = 0; i < this.mAddrList.length; i++) {
                    //             this.mAddrList[i].is_default = false;
                    //         }
                    //     }
                    //     this.mAddrList.push(addr);
                    //     this.mAddr = addr;
                    // }
                    if (this.mAddrIndex === -1) {
                        if (this.mAddrList.length > 1 && this.mAddrList[0].is_default) {
                            if (addr.is_default) {
                                this.mAddrList[0].is_default = false
                                this.mAddrList.splice(0, 0, addr)
                            } else {
                                this.mAddrList.splice(1, 0, addr)
                            }
                        } else {
                            this.mAddrList.splice(0, 0, addr)
                        }
                    } else if (addr.is_default && !this.mAddr.is_default) {
                        this.mAddrList[0].is_default = false;
                        this.mAddrList.splice(this.mAddrIndex, 1)
                        this.mAddrList.splice(0, 0, addr)
                    } else {
                        this.mAddrList.splice(this.mAddrIndex, 1, addr)
                    }
                }
                this.mAddrEditShow = false;
            },
            onAddrDelete (id, index) {
                if (!id) {
                    return;
                }
                this.$Modal.confirm({
                    title: this.$t('common.alert_title'),
                    content: this.$t('common.delete_confirm'),
                    onOk: () => {
                        this.busy = true;
                        httpDelete('/v1/user/address/' + id).then(() => {
                            this.mAddrList.splice(index, 1)
                        }).catch(() => {
                        }).finally(() => {
                            this.busy = false;
                        });
                    }
                });
            },
            addrChoice: function (addr) {
                this.$emit('on-click', addr)
            },
            handleBack: function () {
                if (this.isWindow) {
                    this.$emit('on-back')
                } else {
                    this.$router.go(-1)
                }
            },
            changeDefault: function (isDefault, addr, index) {
                this.setDefaultLoading = true
                httpPost('/v1/user/address/' + addr.id, addr, null).then(() => {
                    if (isDefault && index !== 0) {
                        this.mAddrList[0].is_default = false
                        this.mAddrList.splice(index, 1)
                        this.mAddrList.splice(0, 0, addr)
                    }
                }).catch(() => {
                    this.mAddrList[index].is_default = !isDefault
                }).finally(() => {
                    this.setDefaultLoading = false;
                });
            }
        },
        created () {
            if (this.$store.state.addresses) {
                this.mAddrList = this.$store.state.addresses;
            }
            // 刷新收货列表
            this.loading = !this.mAddrList || this.mAddrList.length === 0;
            if (this.loading) {
                this.$Spin.show();
            }
            if (this.$store.state.postcode == null) {
                this.$store.dispatch('loadPostcode');
            }
            this.$store.dispatch('loadAddresses').then((addresses) => {
                this.mAddrList = addresses;
            }).finally(() => {
                this.loading = false;
                this.$Spin.hide();
            });
        }
    }
</script>
